import React, { useState } from "react";
import "./auth.css";
import logo from "../../Asserts/Images/b2blogoo.png";
import { useNavigate } from "react-router-dom";
import forgot_img from "../../Asserts/Images/forgotPasswordImg.png";
import { message } from "antd"; // ✅ For showing success/error messages
import Instance from "../../AxiosConfig";
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
    if (!email) {
      message.warning("Please enter your email address");
      return;
    }

    try {
      setLoading(true);
      const response = await Instance.post("/auth/send-otp", {
        email: email,
      });
      console.log("OTP Response:", response);
      if (response.data) {
        message.success(response.data.message || "OTP sent successfully");
        navigate("/otp-verification", { state: { email } });
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      if (error.response && error.response.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <div className="container-fluid">
        <div className="row">
          {/* Left side image */}
          <div className="col-md-6">
            <div className="forgot-image">
              <img src={forgot_img} alt="Forgot Password" />
            </div>
          </div>

          {/* Right side form */}
          <div className="col-md-6">
            <div className="forgot-form">
              <div className="d-flex justify-content-center">
                <img src={logo} alt="EQCAS Logo" className="logo" />
              </div>

              <div className="forgot-content mt-2">
                <h2>Forgot Password</h2>
                <p>Enter your registered email to receive OTP</p>
              </div>

              <div>
                <label htmlFor="email" className="form-label forgot-label">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                />
              </div>

              <div className="mt-3">
                <button
                  className="forgot-btn"
                  onClick={handleSendOtp}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Continue"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
